import Map from '../modules/map.babel';

document.addEventListener('DOMContentLoaded', () => {
    const mapBlock = document.querySelector('.map-block');

    if (mapBlock) {
        /**
         * toggle showing main content
         */
        mapBlock.querySelector('.map-block__toggle').addEventListener('click', (e) => {
            mapBlock.classList.toggle('map-block--open');
            e.target.ariaExpanded = e.target.ariaExpanded !== 'true';
            mapBlock.querySelector('.map-block__description').ariaHidden =
                mapBlock.querySelector('.map-block__description').ariaHidden !== 'true';
            mapBlock.querySelector('.map-block__collapsible-items').ariaHidden =
                mapBlock.querySelector('.map-block__collapsible-items').ariaHidden !== 'true';
        });

        /**
         * toggle showing item content
         */
        [...mapBlock.querySelectorAll('.map-block__item')].forEach((item) => {
            item.querySelector('.map-block__cta').addEventListener('click', (e) => {
                item.classList.toggle('map-block__item--open');
                e.target.ariaExpanded = e.target.ariaExpanded !== 'true';
                item.querySelector('.map-block__content-wrapper').ariaHidden =
                    item.querySelector('.map-block__content-wrapper').ariaHidden !== 'true';
            });
        });

        /**
         * correct aria for media queries
         */
        const mediaQuery = window.matchMedia('(min-width: 768px)');
        const resetAria = (mediaQuery) => {
            if (mediaQuery.matches) {
                mapBlock.querySelector('.map-block__toggle').removeAttribute('aria-expanded');
                mapBlock.querySelector('.map-block__description').removeAttribute('aria-hidden');
                mapBlock
                    .querySelector('.map-block__collapsible-items')
                    .removeAttribute('aria-hidden');
            } else {
                mapBlock.classList.remove('map-block--open');
                mapBlock.querySelector('.map-block__toggle').ariaExpanded = 'false';
                mapBlock.querySelector('.map-block__description').ariaHidden = 'true';
                mapBlock.querySelector('.map-block__collapsible-items').ariaHidden = 'true';
            }
        };

        resetAria(mediaQuery);

        window.addEventListener('resize', () => {
            resetAria(mediaQuery);
        });
    }
});

window.initMap = () => {
    Map();
};
